(function ($, root, undefined) {
  $(document).ready(function(){
    console.log('Sleepless Media Init');
    var quickBuyState = "closed"
    $(document).on('click', '.smQuickBuy__stepOneButton', function(event) {
      event.stopPropagation(); // prevent bubbling to the document click below
    
      const $stepTwo = $(this).parent().find('.smQuickBuy__stepTwo');
    
      if (quickBuyState === "closed") {
        $stepTwo.fadeIn();
        quickBuyState = "open";
      } else {
        $('.smQuickBuy__stepTwo').fadeOut(); // hide all
        $stepTwo.fadeIn(); // reopen this one
        quickBuyState = "open";
      }
    });
    
    // Handle click outside of .smQuickBuy__stepTwo
 
    $(document).on('click', function(event) {
      const $target = $(event.target);
    
      if (!$target.closest('.smQuickBuy__stepTwo').length) {
        $('.smQuickBuy__stepTwo').fadeOut();
        quickBuyState = "closed";
      }
    });
    
    var adding = false;

    function smAddToCart(variantId, quantity = 1) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          id: variantId,
          quantity: quantity
        },
        dataType: 'json',
        success: function(response) {
          console.log('Added to cart:', response);
          adding = false;
          // Optionally update cart UI or show a message here
        },
        error: function(error) {
          console.error('Add to cart failed:', error.responseJSON?.description || error.statusText);
        }
      });
    }


    $('.smQuickBuy__stepTwoSizeButton').on('click', function(){
      if (adding == false){
        adding = true;
        var selectedID = 0;
        var selectedAvailable = "false";
        var selectedSize = $(this).attr('data-size');
        var selectedColor = $(this).closest('.product-card').find('.product-card__info fieldset :checked').attr('value');

        $(this).closest('.smQuickBuy__stepTwo').find('option').each(function(){
          var optionArray = $(this).attr('data-title').split('|');
          var optionColor = optionArray[0];
          var optionSize = optionArray[1];
          if ((selectedSize * 1) == (optionSize * 1) && selectedColor == optionColor){
            selectedID = $(this).attr('value');
            selectedAvailable = $(this).attr('data-available');
          }
        });
        if (selectedAvailable == "true"){
          smAddToCart(selectedID);
        }
      }
    });

    function setSizeOOS(productCard, specColor = false){
      productCard.find('.smQuickBuy__stepTwoSizeButton').removeClass('smQuickBuy__stepTwoSizeButton--oos');
      var selectedColor = productCard.find('.product-card__info fieldset :checked').attr('value');
      if (specColor != false){
        selectedColor = specColor;
      }
      var OOSList = [];
      productCard.find('.smQuickBuy__stepTwo').find('option').each(function(){
        var optionArray = $(this).attr('data-title').split('|');
        var optionAvailable = $(this).attr('data-available');
        var optionColor = optionArray[0];
        var optionSize = optionArray[1];
        if (selectedColor == optionColor){
          if (optionAvailable == "false"){
            OOSList.push(optionSize);
          }
        }
      });
      for (i=0;i<OOSList.length;i++){
        productCard.find('.smQuickBuy__stepTwoSizeButton[data-size="'+OOSList[i]+'"]').addClass('smQuickBuy__stepTwoSizeButton--oos');
      }
    }

    $('.product-card').each(function(){
      var thisThing = $(this);
      setSizeOOS(thisThing);
    });

    $('.product-card__info .color-swatch').on('click', function(){
      var thisThing = $(this).closest('.product-card');
      setSizeOOS(thisThing, $(this).attr('title'));
    });
    
  });
})(jQuery, this);